import React from 'react';
import { ICompanyFormationQuestion } from '../../../../../../Interfaces/ICompanyFormationQuestion';
import { ICompanyFormationOption } from '../../../../../../Interfaces/ICompanyFormationOption';
import { Divider, Grid } from '@mui/material';
import { ICompanyFormationAnswer } from '../../../../../../Interfaces/ICompanyFormationAnswer';

interface IProps {
  companyFormationAnswerArray: ICompanyFormationAnswer[];
  companyFormationQuestionArray: ICompanyFormationQuestion[];
  companyFormationOptionArray: ICompanyFormationOption[];
}

export const CompanyFormationAnswerSummary: React.FC<IProps> = props => {
  return (
    <>
      <Grid container spacing={2} ml={5} mt={1}>
        {props.companyFormationAnswerArray.map(
          (companyFormationAnswerObject, index) => {
            const foundQuestion = props.companyFormationQuestionArray.find(
              x =>
                x.idCompanyFormationQuestion ===
                companyFormationAnswerObject.idCompanyFormationQuestion
            );
            const foundOption = props.companyFormationOptionArray.find(
              x =>
                x.idCompanyFormationOption ===
                companyFormationAnswerObject.idCompanyFormationOption
            );

            if (foundQuestion === undefined) {
              return (
                <Grid item sm={12} key={index}>
                  <b>Fehler</b>
                </Grid>
              );
            } else if (
              foundOption === undefined ||
              foundOption.idCompanyFormationOption === -1
            ) {
              return (
                <React.Fragment key={index}>
                  <Grid item sm={4}>
                    <b>{foundQuestion.CompanyFormationQuestion}:</b>
                  </Grid>
                  <Grid item sm={8}>
                    -
                  </Grid>
                </React.Fragment>
              );
            } else {
              return (
                <React.Fragment key={index}>
                  <Grid item sm={4}>
                    <b>{foundQuestion.CompanyFormationQuestion}:</b>
                  </Grid>
                  <Grid item sm={8}>
                    {foundOption.CompanyFormationOption}
                  </Grid>
                  {(Boolean(foundOption.allowNumberValue) ||
                    Boolean(foundOption.allowTextfield)) && (
                    <>
                      <Grid item sm={4}></Grid>
                      <Grid item sm={8}>
                        {foundOption.allowNumberValue
                          ? companyFormationAnswerObject.NumberValue
                          : companyFormationAnswerObject.TextValue}
                      </Grid>
                    </>
                  )}
                </React.Fragment>
              );
            }
          }
        )}
        <Grid item xs={12}>
          <Divider sx={{ mt: 2, mr: 15, borderColor: 'text.primary' }} />
        </Grid>
      </Grid>
    </>
  );
};
